import request from '../request.js'

//新增公共字段(叶凡)
const savePublicField = function (data) {
    return request({
        url: 'analysisPublicField/savePublicField',
        method: 'post',
        data
    })
}

//查询业务字段列表(叶凡)
const getPublicFields = function (data) {
    return request({
        url: 'analysisPublicField/getPublicFields',
        method: 'post',
        data
    })
}

//删除公共字段(叶凡)
const deleteField = function (data) {
    return request({
        url: 'analysisPublicField/deleteField',
        method: 'post',
        data
    })
}

//编辑业务字段时获取业务字段信息(叶凡)
const getFieldInfo = function (data) {
    return request({
        url: 'analysisPublicField/getFieldInfo',
        method: 'post',
        data
    })
}

//根据模板类型查询业务模板(叶凡)
const getAnalysisTemplates = function (data) {
    return request({
        url: 'analysisFormTemplate/getAnalysisTemplates',
        method: 'post',
        data
    })
}

//业务模板列表启用开关改变模板有效性(叶凡)
const changeTemplateFlag = function (data) {
    return request({
        url: 'analysisFormTemplate/changeTemplateFlag',
        method: 'post',
        data
    })
}

//保存业务模板(叶凡)
const saveAnalysisFormTemplate = function (data) {
    return request({
        url: 'analysisFormTemplate/saveAnalysisFormTemplate',
        method: 'post',
        data
    })
}

//根据模板id获取模板信息(叶凡)
const getTemplateInfo = function (data) {
    return request({
        url: 'analysisFormTemplate/getTemplateInfo',
        method: 'post',
        data
    })
}

//获取工程类型、区块名等(叶凡)
const getTypeList = function (data) {
    return request({
        url: 'analysisFormTemplate/getTypeList',
        method: 'post',
        data
    })
}

//获取模板关联的动态表单字段及字段值(叶凡)
const getFieldsAndValue = function (data) {
    return request({
        url: 'analysisFormTemplate/getFieldsAndValue',
        method: 'post',
        data
    })
}

//保存六算基本信息动态表单字段值(叶凡)
const saveBasicInfoProjects = function (data) {
    return request({
        url: 'analysisDynamicBlock/saveBasicInfoProjects',
        method: 'post',
        data
    })
}

//保存项目结构基本信息动态表单及字段值(叶凡)
const saveBasicInfoSingleProjects = function (data) {
    return request({
        url: 'analysisDynamicBlock/saveBasicInfoSingleProjects',
        method: 'post',
        data
    })
}

//获取所有的关联字段(叶凡)
const getRelatedFields = function (data) {
    return request({
        url: 'analysisPublicField/getRelatedFields',
        method: 'post',
        data
    })
}

//获取项目结构模板关联的动态表单字段及字段值(叶凡)
const structureFieldsAndValue = function (data) {
    return request({
        url: 'analysisFormTemplate/structureFieldsAndValue',
        method: 'post',
        data
    })
}

//按条件筛选资源价格(叶凡)
const selectResourcePrices = function (data) {
    return request({
        url: 'resourcesPriceAh/selectResourcePrices',
        method: 'post',
        data
    })
}

// 获取单项工程 工程内容(叶凡)
const getNodeTrees = function (data) {
    return request({
        url: 'proTree/getNodeTrees',
        method: 'post',
        data
    })
}

// 单项工程 工程内容 保存、提交(叶凡)
const saveProTrees = function (data) {
    return request({
        url: 'proTree/saveProTrees',
        method: 'post',
        data
    })
}

// 项目结构 模板配置 (叶凡)
const getNewTypeList = function (data) {
    return request({
        url: 'proTree/getTypeList',
        method: 'post',
        data
    })
}

// 新项目结构 模板配置 (叶凡)
const getProFieldsAndValue = function (data) {
    return request({
        url: 'proTree/getFieldsAndValue',
        method: 'post',
        data
    })
}

// 新项目结构 模板配置保存 (叶凡)
const saveProFieldsAndValue = function (data) {
    return request({
        url: 'proTree/saveFieldsAndValue',
        method: 'post',
        data
    })
}

//业务模板列表启用开关改变模板有效性(叶凡) --- 新
const changeTemplateFlagNew = function (data) {
    return request({
        url: 'proTree/changeTemplateFlag',
        method: 'post',
        data
    })
}

//业务模板导入模板 --- 郑志会 
const saveExcelTemplate = function (data) {
    return request({
        url: 'analysisFormTemplate/saveExcelTemplate',
        method: 'post',
        data
    })
}

//项目结构导入模板 --- 方祥 
const importBasicInfo = function (data) {
    return request({
        baseURL: 'http://172.16.0.70:8080/',
        url: 'proTree/importBasicInfo',
        method: 'post',
        data
    })
}

export {
    getTypeList,
    deleteField,
    getFieldInfo,
    getTemplateInfo,
    savePublicField,
    getPublicFields,
    getRelatedFields,
    getFieldsAndValue,
    changeTemplateFlag,
    getAnalysisTemplates,
    selectResourcePrices,
    saveBasicInfoProjects,
    structureFieldsAndValue,
    saveAnalysisFormTemplate,
    saveBasicInfoSingleProjects,
    getNodeTrees,
    saveProTrees,
    getNewTypeList,
    getProFieldsAndValue,
    saveProFieldsAndValue,
    changeTemplateFlagNew,
    saveExcelTemplate,
    importBasicInfo,
}
